<div class="modal-trading-view">
  <div class="header">
    <mat-icon class="icon-chart" svgIcon="line-chart-sidebar"></mat-icon>
    <span>{{title}}</span>
    <mat-icon class="expand-btn" svgIcon="expand" (click)="expand()"></mat-icon>
    <mat-icon class="close-btn" svgIcon="close" (click)="close()"></mat-icon>
  </div>

  <trading-view *ngIf="customGraphicToken" [customToken]="customGraphicToken" parentComponent="tv-modal-trading-view">
  </trading-view>
</div>
